import { Suspense } from 'react'

import { AnyRoute, Outlet, createRoute } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { CircularProgress } from 'ui/components'

import { customerVendorRoute } from './CustomerVendor'

export const bankCustomerVendorRoutingNode = <T extends AnyRoute>(rootRoute: T) => {
  const customerVendorIndexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: routes.bank.customerVendors.index,
    component: () => (
      <Suspense fallback={<CircularProgress centered />}>
        <Outlet />
      </Suspense>
    )
  })

  return customerVendorIndexRoute.addChildren([
    customerVendorRoute<typeof customerVendorIndexRoute>(customerVendorIndexRoute)
  ])
}
